import { useEffect, useState } from 'react'

/*
 * Verzoegerter Wert.
 *
 * Die Listen filtern und suchen ohne Knopfdruck. Ohne Verzoegerung schickte
 * jeder Tastendruck eine Anfrage — der Server sieht dann acht Anfragen fuer
 * ein Wort, und die Antwort auf den halben Suchbegriff kann die auf den ganzen
 * ueberholen.
 */
export default function useDebouncedValue(value, delay = 400) {
	const [debounced, setDebounced] = useState(value)

	useEffect(() => {
		const timer = setTimeout(() => setDebounced(value), delay)
		return () => clearTimeout(timer)
	}, [value, delay])

	return debounced
}
